module.exports = __webpack_public_path__ + "img/congratulations.ad60e159.gif";